import React, {useState} from 'react';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { useQuery } from "@tanstack/react-query";
import { get } from "@utils/axios_api";
import { useNavigate } from "react-router-dom";

const getYm = (d) => ({ y: d.getFullYear(), m: d.getMonth() + 1 });
const MainAdmin = () => {

  const navigate = useNavigate();
  const [ym, setYm] = useState(() => getYm(new Date()));

const { data: events = [] } = useQuery(
    ["calendarLectures", ym.y, ym.m],
    async () => {
      const { result } = await get("/admin/main/calendar", { params: { year: ym.y, month: ym.m }, });

      return result.flatMap((lec) => {
        const header = `[${lec.eduNo}차] ${lec.eduCategoryNm} (${lec.eduHours}시간)`;

        const isMulti = lec.lastDt && lec.lastDt !== lec.firstDt;
        // 공통(첫째 날)
        const e1 = {
        id   : `${lec.lectureId}-1`,
        title: isMulti
                ? `${header}\n${lec.lectureNm} (1일차)`
                : `${header}\n${lec.lectureNm}`,
        start: lec.firstDt,
        allDay: true,
        className: isMulti ? "cal-multi" : "cal-single", 
        };
        if (isMulti) {
            return [
                e1,
                {
                ...e1,
                id   : `${lec.lectureId}-2`,
                title: `${header}\n${lec.lectureNm} (2일차)`,
                start: lec.lastDt,
                },
            ];
        }
        return [e1];
      });
    },
    { keepPreviousData: true }
  );




return (
<>
    <div className="contents-wrap">
        <div className="calendar-wrap">
            <FullCalendar
                plugins={[dayGridPlugin]}
                locale="ko"
                weekends={false}
                aspectRatio={2.3}
                initialView="dayGridMonth"
                events={events}
                buttonText={{ today:'오늘' }}
                headerToolbar={{ left: "prev,next today", center: "title", right: "" }}
                /* 월 넘길 때 : view.currentStart 가 반드시 '해당 달 1일' */
                datesSet={(info) => setYm(getYm(info.view.currentStart))}
                eventClick={(info) => {
                    const lectureId = info.event.id.split("-")[0];
                    navigate(`/master/lecture/${lectureId}`);
                }}
                eventContent={({ event }) => {
                /* 줄 2개로 분리 */
                const [raw1, raw2] = event.title.split("\n");


                const m1 = raw1.match(/^\[(\d+차)]\s+(.+)\s+\((\d+시간)\)$/);
                const phase   = m1 ? m1[1] : "";         // 1차
                const catName = m1 ? m1[2] : raw1;       // 근로자안전교육>건설
                const hours   = m1 ? m1[3] : "";         // 16시간

                let lectureNm = raw2 ?? "";
                let dayBadge  = "";
                const m2 = raw2 && raw2.match(/^(.+)\s+\((\d일차)\)$/);
                if (m2) {
                    lectureNm = m2[1];      // 프론트화면테스트12
                    dayBadge  = m2[2];      // 1일차
                }
                  return (
                    <>
                    <div className="cal-line1">
                        <span className="cal-phase">[{phase}]</span>{" "}
                        <span className="cal-cat">{catName}</span>{" "}
                        <span className="cal-hours">({hours})</span>
                    </div>
                    {lectureNm && (
                        <div className="cal-line2">
                        <span className="cal-lecture">{lectureNm}</span>{" "}
                        {dayBadge && <span className="cal-day">{`(${dayBadge})`}</span>}
                        </div>
                    )}
                    </>
                    );
                }}
                

            />
        </div>
    </div>
</>
);
}


export {MainAdmin} ;